/**
 * 装飾ラン → 描画に必要な素材の解決（表示層のデコード責務のうち、宣言の引き当て部分）
 *
 * エージェント向け規約:
 * - React非依存の純関数だけを置く。JSXやDOM APIをここへ持ち込まない
 * - 装飾固有の分岐を書かない。判断材料は definitions.ts の宣言だけから引く
 * - ARIA属性など「kind をどうDOMで実現するか」は消費側アプリの汎用実装が持つ。
 *   ここが決めるのは「どの装飾がどの kind か」まで
 */

import { DEFINITION_BY_CLASS_NAME, INTERACTIVE_CLASS_NAME, type PuaActiveInteraction } from "./definitions"

/**
 * ランに効く装飾のうち、対話を持つ最初のもの（＝最も外側）を返す。無ければ null。
 *
 * 現状 wrap() がネストを拒否するため実際には高々1個だが、tokenize はネストを表現できる。
 * 「外側優先で1個だけ効く」と仕様を固定し、将来ネストを許しても曖昧にならないようにする。
 */
export function resolveRunInteraction(classNames: readonly string[]): PuaActiveInteraction | null {
  for (const className of classNames) {
    const interaction = DEFINITION_BY_CLASS_NAME.get(className)?.interaction
    if (interaction !== undefined && interaction.kind !== "static") {
      return interaction
    }
  }
  return null
}

/**
 * ランに付けるCSSクラスを組み立てる。
 * 対話を持つランには共通クラスが加わり、カーソルやフォーカスリングが pua.css 側で当たる。
 */
export function resolveRunClassName(classNames: readonly string[]): string {
  if (resolveRunInteraction(classNames) === null) {
    return classNames.join(" ")
  }
  return [...classNames, INTERACTIVE_CLASS_NAME].join(" ")
}
